import * as React from 'react';
import styles from './sidebar.module.css';
import { SidebarList } from './sidebar-list.component';
import { useGoal } from '../../../contexts/goal/goal.context';
import { convertStringtoDollarString } from '../../../helpers/formathelper';
import { LocalStorageUtils } from '@assetmark/ui-kit/dist/utils/local-storage.utils';
import { GOAL_KEY } from '../../../constants/storage.constant';
import { GoalTypeEnum } from "../../../lib/das-api/model/goalTypeEnum";

export type TStateProps = {
	subModule?: string | undefined | '';
	investorState?: any;
};

export const TargetSideBarComponent: React.FC<TStateProps> = () => {
	const { goals } = useGoal();
	const [investTypeEnum, setInvestTypeEnum] = React.useState<string>('');

React.useEffect(() => {
	typeEnum();
}, []);

const typeEnum = () => {
	const enumType: any = LocalStorageUtils.getItem(GOAL_KEY).getOrElse(null);
	if(enumType && enumType !== null && enumType.investmentTypeEnum) {
		setInvestTypeEnum(enumType.investmentTypeEnum);
	}
};

	return (
		<div className={styles.sideMenu}>
			<nav className={styles.sideMenuNavBar} role="navigation">
				<ul className={styles.rowFlex}>
					<SidebarList
						text={'1. Investment Target'}
						propsValue={`${investTypeEnum === GoalTypeEnum.GeneralSavings && goals.TargetAmount !== 0 
						? `${convertStringtoDollarString(goals.TargetAmount)}` : ''}`}
						activeClassName={styles.active}
					/>
				</ul>
			</nav>
		</div>
	);
};
